'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _PrivacyTogglePills = require('./components/PrivacyTogglePills.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_PrivacyTogglePills).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/shared-privacy-toggle-pills/lib/index.js
// module id = 1502
// module chunks = 1